import { Context } from ".."
import { defaultErrorHandler } from "./actions"

export async function getRegionByZipCodeAction(
  context: Context,
  data: string,
) {
  try {
    context.state.lookupRegion = await context.effects.getRegionByZipCode(data)
  } catch (err) {
    defaultErrorHandler(context, err)
  }
}